import PropTypes from 'prop-types';
import React from 'react';

import * as FileConstants from 'folder-items/FileConstants';
import NumericInput from 'ui-library/inputs/NumericInput';
import {ElementKeyboardEvent, NumericInputChangeEvent} from 'util/Types';

interface NumericValueEditorProps {
  autoFocus: boolean;
  defaultValue?: FileConstants.SchemaTag;
  onChange: (value: Partial<FileConstants.SchemaTag>) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  placeholder?: string;
  valueAccessorKey: keyof FileConstants.SchemaTag;
  useStringValue?: boolean;
  validateInteger?: boolean;
}

class NumericValueEditor extends React.Component<NumericValueEditorProps> {
  static propTypes = {
    autoFocus: PropTypes.bool.isRequired,
    defaultValue: FileConstants.TAG_SHAPE,
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    valueAccessorKey: PropTypes.string.isRequired,
    useStringValue: PropTypes.bool,
    validateInteger: PropTypes.bool,
  };

  _handleChange = (e: NumericInputChangeEvent): void => {
    const proposedValue =
      this.props.useStringValue || e.target.numericValue == null ? e.target.value : e.target.numericValue;
    this.props.onChange({
      [this.props.valueAccessorKey]: proposedValue === '' ? null : proposedValue,
      value: e.target.value,
    });
  };

  render(): JSX.Element {
    const value = this.props.defaultValue ? this.props.defaultValue.value : null;
    return (
      <NumericInput
        focusOnMount={this.props.autoFocus}
        onKeyDown={this.props.onKeyDown}
        onChange={this._handleChange}
        placeholder={this.props.placeholder}
        value={value}
        validateInteger={this.props.validateInteger}
      />
    );
  }
}

export default NumericValueEditor;
